import s from './ReviewProgress.module.css';

export default function ReviewProgress({ current, total }) {
  if (!total) return null;
  return (
    <div className={s.wrap} aria-label={`Card ${current} of ${total}`}>
      <span className={s.current}>{current}</span>
      <span className={s.divider}>/</span>
      <span className={s.total}>{total}</span>
    </div>
  );
}
